document.addEventListener('DOMContentLoaded', function () {
  class CustomCollectionTabs {
    constructor() {
      this.tabsContainer = document.querySelector('.custom-collection-tabs');
      if (!this.tabsContainer) return;

      this.tabButtons = this.tabsContainer.querySelectorAll('.tab-button');
      this.collectionProducts = this.tabsContainer.querySelectorAll('.collection-products');
      this.progressSegments = this.tabsContainer.querySelectorAll('.progress-segment');
      this.viewAllBtn = this.tabsContainer.querySelector('.view-all-btn');
      this.splideInstances = {};
      this.carouselProgressFills = {};
      this.currentActiveIndex = 0;

      this.init();
    }

    init() {
      this.createCarouselProgressBars();
      this.initializeSplide();
      this.bindEvents();
      this.updateViewAllLink();
      this.setActiveTab(0);
    }

    createCarouselProgressBars() {
      this.collectionProducts.forEach((productContainer, index) => {
        const progressContainer = document.createElement('div');
        progressContainer.className = 'carousel-progress-container';

        const progressBar = document.createElement('div');
        progressBar.className = 'carousel-progress-bar';

        const progressFill = document.createElement('div');
        progressFill.className = 'carousel-progress-fill';
        progressFill.dataset.index = index;

        progressBar.appendChild(progressFill);
        progressContainer.appendChild(progressBar);
        productContainer.appendChild(progressContainer);

        this.carouselProgressFills[index] = progressFill;
      });
    }

    initializeSplide() {
      this.collectionProducts.forEach((productContainer, index) => {
        const splideElement = productContainer.querySelector('.splide');
        if (!splideElement) return;

        const isMobile = window.innerWidth <= 768;
        const isTablet = window.innerWidth > 768 && window.innerWidth <= 1024;

        let perPage = 4;
        let gap = '24px';

        if (isMobile) {
          perPage = 2;
          // gap = '15px';
        } else if (isTablet) {
          perPage = 3;
          gap = '18px';
        }

        const splideConfig = {
          type: 'slide',
          perPage: perPage,
          perMove: perPage, 
          gap: gap,
          pagination: false,
          arrows: !isMobile,
          drag: true,
          keyboard: true,
          focus: 0,
          trimSpace: true,
          autoWidth: false,
          slideFocus: false,
          isNavigation: false,
          updateOnMove: true,
          rewind: false, 
          breakpoints: {
            768: {
              perPage: 2,
              perMove: 2, 
              arrows: false,
              gap: '8px'
            },
            1024: {
              perPage: 2,
              perMove: 3, 
              gap: '18px'
            }
          }
        };

        try {
          const splideInstance = new Splide(splideElement, splideConfig);

          splideInstance.on('moved', (newIndex, prevIndex) => {
            this.updateCarouselProgressBar(index, newIndex, splideInstance, prevIndex);
            this.checkArrowState(splideInstance, splideElement);
          });

          splideInstance.on('mounted', () => {
            this.initializeCarouselProgressBar(index, splideInstance);
            this.checkArrowState(splideInstance, splideElement);
          });

          splideInstance.mount(); 

          this.splideInstances[index] = splideInstance;

          const nextArrow = splideElement.querySelector('.splide__arrow--next');
          const prevArrow = splideElement.querySelector('.splide__arrow--prev');

          if (nextArrow) {
            nextArrow.addEventListener('click', (e) => {
              const maxIndex = splideInstance.length - splideInstance.options.perPage;
              if (splideInstance.index >= maxIndex) {
                e.preventDefault();
                e.stopImmediatePropagation();
                return false;
              }
            });
          }

          if (prevArrow) {
            prevArrow.addEventListener('click', (e) => {
              if (splideInstance.index <= 0) {
                e.preventDefault();
                e.stopImmediatePropagation();
                return false;
              }
            });
          }

        } catch (error) {
          console.error('Error initializing Splide:', error);
        }
      });
    }

    bindEvents() {
      this.tabButtons.forEach((button, index) => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          this.setActiveTab(index);
        });
      });

      window.addEventListener('resize', this.debounce(() => {
        this.handleResize();
      }, 250));

      if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:block:select', (event) => {
          const blockIndex = Array.from(this.tabButtons).findIndex(btn =>
            btn.closest('[data-block-id]') === event.target
          );
          if (blockIndex !== -1) {
            this.setActiveTab(blockIndex);
          }
        });
      }
    }

    setActiveTab(index) {
      if (index === this.currentActiveIndex) return;

      this.tabButtons.forEach((button, i) => {
        button.classList.toggle('active', i === index);
      });

      this.collectionProducts.forEach((products, i) => {
        products.classList.toggle('active', i === index);
      });

      this.updateMainProgressSegments(index);
      this.updateViewAllLink(index);

      if (this.splideInstances[index]) {
        this.splideInstances[index].go(0);
        setTimeout(() => {
          this.initializeCarouselProgressBar(index, this.splideInstances[index]);
          this.checkArrowState(this.splideInstances[index], this.collectionProducts[index].querySelector('.splide'));
        }, 50);
      }

      this.currentActiveIndex = index;
    }

    updateMainProgressSegments(activeIndex) {
      this.progressSegments.forEach((segment, index) => {
        segment.classList.remove('active');
        if (index === activeIndex) {
          segment.classList.add('active');
        }
      });
    }

    // Updated pagination-based progress bar initialization
    initializeCarouselProgressBar(tabIndex, splideInstance) {
      const progressFill = this.carouselProgressFills[tabIndex];
      if (!progressFill) return;

      const totalSlides = splideInstance.length;
      const perPage = splideInstance.options.perPage;

      // If all products fit in one view, show 100%
      if (totalSlides <= perPage) {
        progressFill.style.width = '100%';
        return;
      }

      // Calculate total number of pages (pagination segments)
      const totalPages = Math.ceil(totalSlides / perPage);
      const currentPage = Math.floor(splideInstance.index / perPage) + 1;
      
      // Calculate percentage based on current page
      const progressPercentage = (currentPage / totalPages) * 100;
      progressFill.style.width = `${progressPercentage}%`;
    }

    // Update progress bar based on current slide and visible products
    updateCarouselProgressBar(tabIndex, slideIndex, splideInstance, prevIndex) {
      if (tabIndex !== this.currentActiveIndex) return;

      const progressFill = this.carouselProgressFills[tabIndex];
      if (!progressFill) return;

      const totalSlides = splideInstance.length;
      const perPage = splideInstance.options.perPage;

      // If all products fit in one view, show 100%
      if (totalSlides <= perPage) {
        progressFill.style.width = '100%';
        return;
      }

      // Calculate progress based on currently viewed products
      // slideIndex is the first visible product, so visible products are slideIndex to slideIndex + perPage - 1
      const lastVisibleIndex = Math.min(slideIndex + perPage - 1, totalSlides - 1);
      const progressPercentage = ((lastVisibleIndex + 1) / totalSlides) * 100;

      // Determine animation direction
      const isForward = prevIndex < slideIndex || prevIndex === -1;

      // Apply animation classes
      progressFill.classList.remove('animate-forward', 'animate-backward');
      
      if (prevIndex !== -1) {
        progressFill.classList.add(isForward ? 'animate-forward' : 'animate-backward');
      }

      // Update progress width
      progressFill.style.width = `${progressPercentage}%`;

      // Remove animation classes after animation completes
      setTimeout(() => {
        progressFill.classList.remove('animate-forward', 'animate-backward');
      }, 300);
    }

    updateViewAllLink(index = this.currentActiveIndex) {
      if (!this.viewAllBtn) return;

      const activeButton = this.tabButtons[index];
      if (activeButton) {
        const collectionHandle = activeButton.dataset.collection;
        if (collectionHandle && collectionHandle !== 'default') {
          this.viewAllBtn.href = `/collections/${collectionHandle}`;
        } else {
          this.viewAllBtn.href = '/collections/all';
        }
      }
    }

    handleResize() {
      const isMobile = window.innerWidth <= 768;
      const hasArrows = this.splideInstances[0] ? this.splideInstances[0].options.arrows : true;
      const shouldHaveArrows = !isMobile;

      if (hasArrows !== shouldHaveArrows) {
        this.destroySplideInstances();
        this.initializeSplide();
      } else {
        Object.values(this.splideInstances).forEach(instance => {
          if (instance && instance.refresh) {
            instance.refresh();
          }
        });
      }
    }

    destroySplideInstances() {
      Object.values(this.splideInstances).forEach(instance => {
        if (instance && instance.destroy) {
          instance.destroy();
        }
      });
      this.splideInstances = {};
    }

    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    checkArrowState(splideInstance, splideElement) {
      const prevArrow = splideElement.querySelector('.splide__arrow--prev');
      const nextArrow = splideElement.querySelector('.splide__arrow--next');

      if (!nextArrow || !prevArrow) return;

      if (splideInstance.index <= 0) {
        prevArrow.setAttribute('disabled', 'true');
      } else {
        prevArrow.removeAttribute('disabled');
      }

      const maxIndex = splideInstance.length - splideInstance.options.perPage;

      if (splideInstance.index >= maxIndex) {
        nextArrow.setAttribute('disabled', 'true');
      } else {
        nextArrow.removeAttribute('disabled');
      }
    }
  }

  const customTabs = new CustomCollectionTabs();
  window.CustomCollectionTabs = customTabs;
});